<template>
  <div id="app">
    <router-view />
  </div>
</template>

<script>
export default {
  data() {
    return {
      token: ''
    }
  },
  watch: {
    $route(to) {
      switch (to.path) {
        case "/":
          this.$router.push("index");
          break;
        default:
          break;
      }
    },
  },
  created() {
    this.token = sessionStorage.getItem('token')
  },

  methods: {
    cheak() {
      this.axios
        .post("/api/Personal/Collection", {
          title: sessionStorage.getItem("token") ? sessionStorage.getItem("token") : sessionStorage.getItem("c2token"),
          /* title: sessionStorage.getItem("token") */
        })
        .then((e) => {
          if (e.data.code == 3) {
            this.$message({
              type: 'warning',
              message: '数据库未有该token值。',
              duration: 2000
            })
            sessionStorage.removeItem("token");
            sessionStorage.removeItem("id");
            sessionStorage.removeItem("roleid");
            sessionStorage.removeItem("status");
            sessionStorage.removeItem("rid");
            sessionStorage.removeItem("township");
            sessionStorage.removeItem("partybrach");
            sessionStorage.removeItem("imgheader");
            sessionStorage.removeItem("mobileid");
            sessionStorage.removeItem("name");
            sessionStorage.removeItem("town");
            sessionStorage.removeItem("reseauStatus");
            sessionStorage.removeItem("pmbid");
            sessionStorage.removeItem('c2token')
            sessionStorage.removeItem('c2userid')
            sessionStorage.removeItem('statuCode')
            this.$router.push("/login");
          }
        });
    },
    /* cTwoToken() {
      this.axios
      .post("/api/Personal/Collection", {
          title: sessionStorage.getItem("c2token"),
        })
        .then((e) => {
          if (e.data.code == 3) {
            this.$message({
              type: 'warning',
              message: '数据库未有该token值0',
              duration: 2000
            })
            sessionStorage.removeItem("token");
            sessionStorage.removeItem("id");
            sessionStorage.removeItem("roleid");
            sessionStorage.removeItem("status");
            sessionStorage.removeItem("rid");
            sessionStorage.removeItem("township");
            sessionStorage.removeItem("partybrach");
            sessionStorage.removeItem("imgheader");
            sessionStorage.removeItem("mobileid");
            sessionStorage.removeItem("name");
            sessionStorage.removeItem("town");
            sessionStorage.removeItem("reseauStatus");
            sessionStorage.removeItem("pmbid");
            sessionStorage.removeItem('c2token')
            sessionStorage.removeItem('c2userid')
            sessionStorage.removeItem('statuCode')
            this.$router.push("/login");
          }
        });
    } */
  },
  mounted() {
    document.title = "东坡区党群e家智慧党建云平台";
    if (sessionStorage.getItem("token") == null && sessionStorage.getItem("c2token") == null) {
      const pathWhiteList = ["/outSide/qrcodeScan", "/outSide/qrMsg", "/hualu", "/login", "/",
      "/pubLicDetail", "/publicDetail", "/allienceActive/allienceActiveReport", "/hualuParty", "/dpTalent", "/loginDp",
      "/updatePassword", "/questionnaire", "/subjectList"]
      if (pathWhiteList.indexOf(this.$route.path) == -1) this.$router.push("/login")
    }
  },
  updated() {
    if (sessionStorage.getItem("token") == null && sessionStorage.getItem("c2token") == null) {
      const pathWhiteList = ["/outSide/qrcodeScan", "/outSide/qrMsg", "/hualu", "/login", "/", "/dppad",
      "/pubLicDetail", "/publicDetail", "/allienceActive/allienceActiveReport", "/hualuParty", "/dpTalent", "/loginDp",
      "/updatePassword", "/questionnaire", "/subjectList"]
      if (pathWhiteList.indexOf(this.$route.path) == -1) this.$router.push("/login")
    }
    if (
      sessionStorage.getItem("roleid") != 6 &&
      sessionStorage.getItem("token") != null
      && sessionStorage.getItem("c2token") != null
    ) {
      this.cheak();
    } /* else if (
      sessionStorage.getItem("roleid") != 6 &&
      sessionStorage.getItem("c2token") != null
    ) {
      this.cTwoToken()
    } */
  },
};
</script>

<style lang="scss" >
@import url('./styles/common.scss');
// html {
//   filter: grayscale(100%);
//   -webkit-filter: grayscale(100%);
//   -moz-filter: grayscale(100%);
//   //-ms-filter: grayscale(100%);
//   -o-filter: grayscale(100%);
//   filter:progid:DXImageTransform.Microsoft.BasicImage(grayscale=1);
//   -webkit-filter: grayscale(1);
// }
.el-message {
  min-width: 6rem !important;
}
.el-message-box {
  width: 80% !important;
}
.w-e-menu {
  z-index: 2 !important;
}
.w-e-text-container {
  z-index: 1 !important;
}
</style>


